import { apiClient } from './api';

export interface GenerateCriticalBusinessRequest {
  company_name: string;
  location?: string;
  employee_count?: string;
  business_description: string;
}

export interface CriticalBusinessItem {
  id: string;
  name: string;
  reason: string;
}

export interface GenerateCriticalBusinessResponse {
  success: boolean;
  critical_business: string;
  critical_business_items?: Array<CriticalBusinessItem>;
  message?: string;
  error?: string;
}

export const generateCriticalBusiness = async (
  request: GenerateCriticalBusinessRequest
): Promise<GenerateCriticalBusinessResponse> => {
  const response = await apiClient.postRaw<GenerateCriticalBusinessResponse>(
    '/api/generate-critical-business',
    request
  );

  return response.data;
};
